import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative py-4 px-4 md:px-0 w-full bg-grey-lighten-1 overflow-y-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppointmentTreatmentSelector = _resolveComponent("AppointmentTreatmentSelector")!
  const _component_TreatmentDetailSelector = _resolveComponent("TreatmentDetailSelector")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog) = $event)),
    scrim: false,
    "max-width": "820px",
    persistent: "",
    "onClick:outside": _ctx.closeAppointment
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.step)
          ? (_openBlock(), _createBlock(_component_AppointmentTreatmentSelector, {
              key: 0,
              class: "ad-body-module",
              onOpenTreatmentStep: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step++)),
              onCloseDialog: _ctx.closeAppointment,
              onSetAllowedClose: _ctx.setAllowedToClose
            }, null, 8, ["onCloseDialog", "onSetAllowedClose"]))
          : _createCommentVNode("", true),
        (_ctx.step === 1)
          ? (_openBlock(), _createBlock(_component_TreatmentDetailSelector, {
              key: 1,
              class: "ad-body-module",
              onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step--)),
              onOnShowSettings: _ctx.onShowSettings
            }, null, 8, ["onOnShowSettings"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClick:outside"]))
}